import { MutationTree, ActionTree, GetterTree } from "@store/vuex.d";
import vuepack from '@shield/vuepack'
const { i18n } = vuepack.config()
class State {}

const getters = {
  country: (state: any) => {
    return {
      AU: i18n.t('app.nation.AU'),
      AT: i18n.t('app.nation.AT'),
      BE: i18n.t('app.nation.BE'),
      CA: i18n.t('app.nation.CA'),
      CN: i18n.t('app.nation.CN'),
      DE: i18n.t('app.nation.DE'),
      ES: i18n.t('app.nation.ES'),
      FR: i18n.t('app.nation.FR'),
      ID: i18n.t('app.nation.ID'),
      IT: i18n.t('app.nation.IT'),
      JP: i18n.t('app.nation.JP'),
      MX: i18n.t('app.nation.MX'),
      MY: i18n.t('app.nation.MY'),
      PH: i18n.t('app.nation.PH'),
      RU: i18n.t('app.nation.RU'),
      SG: i18n.t('app.nation.SG'),
      TH: i18n.t('app.nation.TH'),
      UK: i18n.t('app.nation.UK'),
      US: i18n.t('app.nation.US'),
      VN: i18n.t('app.nation.VN'),
      IN: i18n.t('app.nation.IN'),
      TW: i18n.t('app.nation.TW'),
      HK: i18n.t('app.nation.HK'),
      IE: i18n.t('app.nation.IE'),
      NL: i18n.t('app.nation.NL'),
      PL: i18n.t('app.nation.PL'),
      SE: i18n.t('app.nation.SE'),
      CH: i18n.t('app.nation.CH'),
      ME: i18n.t('app.nation.ME'),
      RO: i18n.t('app.nation.RO'),
      CZ: i18n.t('app.nation.CZ')
    };
  },
  payType: (state: any) => {
    return {
      "register": i18n.t('app.payType.register'),
      "register_and_filing_one_year": i18n.t('app.payType.register_and_filing_one_year'),
      "filing": i18n.t('app.payType.filing'),
      "filing_one_year": i18n.t('app.payType.filing_one_year'),
      "history_or_other": i18n.t('app.payType.history_or_other')
    }
  }
};

export default {
  namespaced: true,
  state: new State(),
  getters,
  modules: {
  }
};
